import {
  FormCapabilities,
  resolveFormCapabilities,
} from 'app/utils/applications/formCapabilities'

type ApplicationWithFormCapabilities = {
  formCapabilities?: Partial<FormCapabilities>
}

export const shouldShowPets = (
  application?: ApplicationWithFormCapabilities | null,
) => resolveFormCapabilities(application?.formCapabilities).hasPetDetails

export const shouldShowSnugScore = (
  application?: ApplicationWithFormCapabilities | null,
) => resolveFormCapabilities(application?.formCapabilities).hasSnugMatchScore
